import { initializeApp } from "firebase/app"
import { connectAuthEmulator, getAuth } from "firebase/auth"
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore"
import { getFunctions, connectFunctionsEmulator } from "firebase/functions"
import { connectStorageEmulator, getStorage } from "firebase/storage"
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check"

declare global {
  interface Window {
    FIREBASE_APPCHECK_DEBUG_TOKEN: boolean | string
  }
}

const env = process.env
const isDev = env.NODE_ENV === env.REACT_APP_DEV
const siteKey = env.REACT_APP_RECAPTCHA_SITE_KEY || ""

const firebaseConfig = {
  apiKey: env.REACT_APP_API_KEY!,
  authDomain: env.REACT_APP_AUTH_DOMAIN,
  projectId: env.REACT_APP_PROJECT_ID,
  storageBucket: env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: env.REACT_APP_MESSAGING_SENDER_ID,
  appId: env.REACT_APP_APP_ID,
  measurementId: env.REACT_APP_MEASUREMENT_ID
}

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db = getFirestore(app)
const functions = getFunctions(app)
const storage = getStorage(app)

if (isDev && typeof window !== "undefined") {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = env.REACT_APP_APPCHECK_DEBUG_TOKEN ?? true
}

if (siteKey) {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = isDev
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(siteKey),
    isTokenAutoRefreshEnabled: !isDev
  })
}

if (isDev) {
  connectFirestoreEmulator(db, "127.0.0.1", 8080)
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: false })
  connectFunctionsEmulator(functions, "127.0.0.1", 5001)
  connectStorageEmulator(storage, "127.0.0.1", 9199)
}

export { auth, db, functions, storage }
